import { createAction } from '@reduxjs/toolkit';

export const clearCompatibilityList = createAction('clearCompatibilityList/clearCompatibilityList');

export const setCompatibilityList = createAction('clearCompatibilityList/setCompatibilityList');
